import { Button } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { UserOutlined } from '@ant-design/icons/lib/icons';
import { Menu, Dropdown } from 'antd';
import { LogoutOutlined } from '@ant-design/icons/lib/icons';
import { FormattedMessage } from 'react-intl';

const StyledButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 2rem;

  & > i.anticon {
    display: inline-flex;
  }
`;

const StyledItem = styled(Menu.Item)`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
`;

interface ProfileButtonProps {
  onLogout: () => any;
  className?: string;
}

export const ProfileButton: React.FC<ProfileButtonProps> = ({
  onLogout,
  className,
}) => {
  const menu = (
    <Menu>
      <StyledItem key="logout" onClick={onLogout}>
        <LogoutOutlined />
        <FormattedMessage id="auth.logout" />
      </StyledItem>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <StyledButton
        type="dashed"
        icon={<UserOutlined />}
        shape="circle"
        className={className}
      />
    </Dropdown>
  );
};
